import { EntityRequestCaruse } from "../../entity/EntityRequestCaruse";

export class DtoRequestCarusesPutRes extends EntityRequestCaruse {}
